// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { infoCardStyles } from "@west/App/Widgets/InfoCard/InfoCard";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

infoCardStyles.container = {
    css: css`
        max-width: 508px;
        height: 100%;
        display: flex;
        flex-direction: column;
    `,
};

infoCardStyles.image = {
    css: css`
        width: 100%;
        height: 200px;
        margin-bottom: 16px;

        ${xScreen("lte", "sm")} {
            height: 167px;
        }

        ${xScreen("lte", "xs")} {
            height: 153px;
        }

        img {
            width: 100%;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

infoCardStyles.title = {
    variant: "h3",
    css: css`
        margin-bottom: 16px;
    `,
};

infoCardStyles.description = {
    as: "div",
    size: 14,
    color: "text.main",
    lineHeight: "22px",
    css: css`
        flex: 1;
        margin-bottom: 20px;

        & > ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            letter-spacing: inherit;
            margin-bottom: 0;
        }
    `,
};

infoCardStyles.buttonContainer = {
    css: css`
        display: flex;
        justify-content: ${({ buttonPosition }: any) => buttonPosition || "flex-start"};
    `,
};
